export default __webpack_public_path__ + "static/media/sa-video-2.4c98701a.mov";